import script from "./SiDebar.vue?vue&type=script&setup=true&lang=js"
export * from "./SiDebar.vue?vue&type=script&setup=true&lang=js"

import "./SiDebar.vue?vue&type=style&index=0&id=715e7268&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-715e7268"]])

export default __exports__